export const messages = {
  en: {
    buyGoldSendParking: {
      title: 'Give Coupons',
      coupon: 'Coupon',
      stock: 'Stock',
      giftAmount: 'Gift Amount',
      licensePlate: 'License Plate',
      phone: 'Phone',
      return: 'Return',
      confirm: 'Confirm',
      requiredTip: 'Required',
      plateTip: 'Please fill in the license plate accurately',
      phoneTip: 'Please fill in the correct phone number',
      insufficientStock: 'Insufficient stock, please purchase coupons first'
    }
  },
  zh: {
    buyGoldSendParking: {
      title: '赠送优惠券',
      coupon: '优惠券',
      stock: '库存',
      giftAmount: '赠送数量',
      licensePlate: '车牌号',
      phone: '电话',
      return: '返回',
      confirm: '确定',
      requiredTip: '必填',
      plateTip: '车牌号请填写准确',
      phoneTip: '电话请填写正确手机号',
      insufficientStock: '库存不足，请先购买优惠卷'
    }
  }
}